import React, { forwardRef } from 'react';

import { MultipleSelectProduct } from './multiple';
import { SingleSelectProduct } from './single';

type SingleSelectProductValueProps = {
  single: true;
  selected?: number;
  onConfirm?: (product_id: number) => void;
};

type MultipleSelectProductValueProps = {
  single: false;
  selected?: number[];
  onConfirm?: (product_ids: number[]) => void;
};

type IProps = {
  endpoint?: string;
  disabled?: boolean;
  inputClearButton?: boolean;
  label?: React.ReactNode;
} & (SingleSelectProductValueProps | MultipleSelectProductValueProps);

export interface ISelectProductMultipleHandles {
  unCheckAll: () => void;
}

const SelectProductComponent: React.ForwardRefRenderFunction<ISelectProductMultipleHandles, IProps> = (
  { label, endpoint, inputClearButton, disabled, ...props },
  ref
) => {
  const defaultProps = { label, endpoint, disabled };

  if (props.single === true) {
    return <SingleSelectProduct {...defaultProps} onConfirm={props.onConfirm} inputClearButton={inputClearButton} />;
  }

  return <MultipleSelectProduct ref={ref} onConfirm={props.onConfirm} selected={props.selected} {...defaultProps} />;
};

export const SelectProduct = forwardRef(SelectProductComponent);
